// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Maschinentransport, MaschinentransportDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useCreateMaschinentransport(): (
  taetigkeitsberichtId: string,
  fuhrparkeintragId: string,
  requestBody: MaschinentransportDaten
) => Promise<Maschinentransport> {
  const getAPI = useGetApi();
  return useCallback(
    async (taetigkeitsberichtId, fuhrparkeintragId, requestBody) =>
      (await getAPI()).maschinentransporte.createMaschinentransport({
        taetigkeitsberichtId,
        fuhrparkeintragId,
        requestBody,
      }),
    [getAPI]
  );
}
